import { cn } from "@corpuscomplete/web-ui/lib/utils";

/**
 * Renders a food icon served from the web app static `/icons/...` path.
 *
 * Contract:
 * - `slug` is best-effort (no DB FK); missing slugs must fall back to `default.svg`.
 * - Asset ownership + delivery details live in `packages/assets/README.md`.
 */
interface FoodIconProps {
  slug: string | null;
  size: "sm" | "md" | "lg";
  className?: string;
  decorative?: boolean;
}

const SIZES = { sm: 32, md: 48, lg: 64 };

export function FoodIcon({ slug, size, className, decorative = false }: FoodIconProps) {
  const dimension = SIZES[size];
  const src = slug ? `/icons/food/${slug}.svg` : "/icons/food/default.svg";

  return (
    <img
      src={src}
      alt={decorative ? "" : (slug ?? "Default Food Icon")}
      aria-hidden={decorative}
      width={dimension}
      height={dimension}
      loading="lazy"
      className={cn("shrink-0", className)}
      onError={(e) => {
        e.currentTarget.src = "/icons/food/default.svg";
      }}
    />
  );
}
